var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blue-footer" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "fo-copy-sec d-none" }, [
        _vm._v(
          "Copyright © 2007 - " +
            _vm._s(new Date().getFullYear()) +
            " BUY1GIVE1 PTE LTD / B1G1 Giving, Inc.\n    "
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "social-sec d-none" }, [
      _c("ul", [
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.facebook.com/b1g1giving",
                target: "_blank"
              }
            },
            [_c("i", { staticClass: "fab fa-facebook-f" })]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: { href: "https://www.twitter.com/B1G1", target: "_blank" }
            },
            [_c("i", { staticClass: "fab fa-x-twitter" })]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.linkedin.com/company/buy1give1/",
                target: "_blank"
              }
            },
            [_c("i", { staticClass: "fab fa-linkedin-in" })]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.instagram.com/buy1give1/",
                target: "_blank"
              }
            },
            [_c("i", { staticClass: "fab fa-instagram" })]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fo-menu-sec" }, [
      _c("ul", [
        _c("li", [
          _c("a", { attrs: { href: "https://b1g1.com/", target: "_blank" } }, [
            _vm._v("B1G1 Home")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://b1g1.com/about-us", target: "_blank" } },
            [_vm._v("About")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://b1g1.helpscoutdocs.com/",
                target: "_blank"
              }
            },
            [_vm._v("Help Center")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://b1g1.com/terms-and-conditions",
                target: "_blank"
              }
            },
            [_vm._v("Terms")]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72fc880a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72fc880a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/Footer.vue
// module id = null
// module chunks = 